export default "__VITE_ASSET__731ea808__"